module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "location"
    }
  }, [_c('layout'), _vm._v(" "), (_vm.isReady) ? _c('div', {
    staticClass: "location-wrapper"
  }, [_c('google-map', {
    attrs: {
      "center": _vm.center,
      "zoom": 14
    }
  }, [_c('google-marker', {
    attrs: {
      "position": _vm.center
    }
  }), _vm._v(" "), _c('google-marker', {
    attrs: {
      "position": _vm.targetPosition
    }
  })], 1), _vm._v(" "), _c('countdown', {
    ref: "countdown",
    attrs: {
      "time": _vm.totalTime * 1000
    },
    on: {
      "countdownend": _vm.timerExpired
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("Time remaining: " + _vm._s(props.hours) + " hours, " + _vm._s(props.minutes) + " minutes, " + _vm._s(props.seconds) + " seconds")]
      }
    }])
  })], 1) : _c('div', {
    staticClass: "location-wrapper"
  }, [_vm._v("\n        Loading...\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4ec4ef4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Location.vue
// module id = 91
// module chunks = 0